<template>
  <!-- 选择商品弹窗 -->
  <el-dialog
    title="选择商品"
    :visible.sync="isSelectDialog"
    width="800px"
    append-to-body
    @close="onClose"
  >
    <el-form :model="searchInfo" :inline="true" label-width="80px">
      <el-form-item label="商品名称">
        <el-input
          style="width: 220px"
          size="small"
          placeholder="请输入商品名称"
          v-model="searchInfo.title"
        ></el-input>
      </el-form-item>
      <el-form-item label="skuId">
        <el-input
          style="width: 220px"
          size="small"
          placeholder="请输入skuId"
          v-model="searchInfo.skuId"
        ></el-input>
      </el-form-item>
      <div class="seach_btn">
        <jd-button type="blue" style="margin-right: 8px" @click="handleSearch"
          >查询</jd-button
        >
        <jd-button type="gley" @click="handleReset()">重置</jd-button>
      </div>
    </el-form>
    <div class="table-box">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="light"
        :header-cell-style="{ background: '#F8F9FA', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="title" label="商品名称"></el-table-column>
        <el-table-column prop="skuId" label="skuId"></el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <jd-button style="margin-right: 12px" @click="onClose">取消</jd-button>
      <jd-button type="break" @click="onComfirm">确定</jd-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SelectAddGood",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    /**加购商品列表 */
    goodList: {
      type: Array,
      default: ()=> []
    },
    /**已选择的商品 */
    selectedGoodList: {
      type: Array,
      default: ()=> []
    }
  },
  data() {
    return {
      isSelectDialog: false,
      searchInfo: {
        title: "",
        skuId: "",
      },
      tableData: [],
      multipleSelection: [],
    };
  },
  watch: {
    value(val) {
      this.isSelectDialog = val;
      if (val) {
        console.log('商品列表>>',this.goodList)
        this.tableData = this.goodList;
        this.onFiliterSelect();
      }
    },
  },
  methods: {
    onClose() {
      // this.$refs.multipleTable.clearSelection();
      this.$emit("input", false);
    },
    onFiliterSelect() {
      let goodSkuIds = this.tableData.map(item => item.skuId);
      if (this.selectedGoodList.length) {
        this.$nextTick(() => {
          this.selectedGoodList.forEach(item => {
            if (goodSkuIds.includes(item.skuId)) {
              this.$refs.multipleTable.toggleRowSelection(item,true);
            }
          })
        })
      }
    },
    handleReset() {
      this.searchInfo = {
        title: "",
        skuId: "",
      };
      this.tableData = this.goodList;
    },
    handleSearch() {
      let searchList1 = this.goodList.filter(item => {
        if(item.title.includes(this.searchInfo.title)) {
          return item
        }
      })
      let searchList2 = searchList1.filter(item => {
        if(item.skuId.includes(this.searchInfo.skuId)) {
          return item
        }
      })
      this.tableData = searchList2;
      console.log('搜索列表',this.tableData)
    },
    handleSelectionChange(val) {
      console.log('val',val)
      this.multipleSelection = val;
    },
    onComfirm() {
      if(!this.multipleSelection.length) return this.$message.info('请选择商品')
      this.$emit('select',{list: this.multipleSelection})
      this.onClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.table-box {
  margin-top: 20px;
}
.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
